import { configureStore } from "@reduxjs/toolkit";
// import counterReducer from "./counterSlice";
// import orderInboxListDataReducer from './orderSlice';     // orderInbox: orderInboxListDataReducer,
import NavReducer from "./navSlice";
import orderReducer from './orderSlice';
import productsReducer from "./productSlice";
import { authReducer } from './authSlice';
// import { userReducer } from "./userSlice";
// import shipmentReducer from './shipmentSlice';
import languageReducer from './comonSlice';
// import stocksReducer from './stockSlice';
// import processLossReducer from './processLossSlice';
import catagoriesReducer from './categoriesSlice';
import adminReducer from './adminSlice'
import bannersReducer from "./bannerSlice";
import bannerReducer from './bannerItemSlice'
import deliverySlice from "./deliverySlice";
import couponReducer from './couponSlice'
import festivalReducer from './festivalSlice'
// import myProfileReducer from './myProfileSlice'
// import partnerProfileReducer from "./partnerProfileSlice";
// import auditTrailReducer from "./auditTrailSlice";
// import tagReducer from './tagSlice'
// import trfUserReducer from './trfUserSlice';




const store = configureStore({
  reducer: {
    nav: NavReducer,
    auth: authReducer,
    order: orderReducer,
    products: productsReducer,
    // shipment: shipmentReducer,
    language: languageReducer,
    // stocks: stocksReducer,
    categories: catagoriesReducer,
    admin: adminReducer,
    banners: bannersReducer,
    banner: bannerReducer,
    deliveryModule: deliverySlice,
    coupon: couponReducer,
    festival: festivalReducer,
    // auditTrails: auditTrailReducer,
    // tag: tagReducer,
    // processLoss: processLossReducer,
    // myProfile: myProfileReducer,
    // partnerProfile: partnerProfileReducer,
    // trfUser: trfUserReducer,
    // users: userReducer
  },
});

export default store;
